<div class="toast-container" *transloco="let t">
  @for(toast of toastService.toasts(); track toast.id){
  <div
    [class]="'toast toast--' + toast.type"
    [attr.role]="toast.type === 'error' ? 'alert' : 'status'"
    [attr.aria-live]="toast.type === 'error' ? 'assertive' : 'polite'"
  >
    <span class="toast-icon" aria-hidden="true">
      <lucide-icon [img]="statusIcon(toast)" [size]="18" [strokeWidth]="2.4" />
    </span>
    <div class="toast-body">
      <p class="toast-title">{{ t(titleKey(toast)) }}</p>
      <span class="toast-message">{{toast.message}}</span>
    </div>
    <button class="close-btn" (click)="toastService.dismiss(toast.id)" [attr.aria-label]="t('common.dismiss')">
      <lucide-icon [img]="Assets.lucideIcons.cancel" [size]="16" [strokeWidth]="2.4" />
    </button>
  </div>
  }
</div>
